import { useEffect, useState } from 'react';

import { Form, FormButton, FormButtonWrap, FormField, FormInput, FormNotice } from 'src/components';
import { recoveryEmailApi, recoveryPhoneNumberApi, useAppDispatch, useRecoverySelector } from 'src/store';
import { formValidatePhoneNumberEmail, formValidateEmail, useInputField, formHandleServerError, libClearPhone } from 'src/toolkit';

import styles from '../../../../../../components/styles/RecoveryStage.module.scss';


export function RecoveryFormMain() {
	const dispatch = useAppDispatch();
	const { isLoading, error } = useRecoverySelector();

	const loginField = useInputField('login');

	const [notice, setNotice] = useState('');

	useEffect(() => {
		if (error) {
			formHandleServerError(error, setNotice, loginField);
		}
	}, [error]);

	const submit = async () => {
		const errors = [];

		errors.push(formValidatePhoneNumberEmail(loginField.value));
		loginField.setErrors(errors[errors.length - 1]);

		const isInvalidForm = !!errors.find(items => items.length > 0);

		if (isInvalidForm) {
			return;
		}

		const byPhoneNumber = formValidateEmail(loginField.value).length > 0;

		const value = loginField.value;

		if (byPhoneNumber) {
			const clearValue = libClearPhone(value);

			return dispatch(recoveryPhoneNumberApi(clearValue));
		}

		dispatch(recoveryEmailApi(value));
	};

	return (
		<Form className={ styles.recoveryPageStageForm } onSubmit={ submit }>
			<FormField
				legend="Номер телефона или E-Mail"
				errors={ loginField.errors }
				required
			>
				<FormInput
					placeholder="Номер телефона или E-Mail"
					name={ loginField.name }
					title="Номер телефона или E-Mail"
					value={ loginField.value }
					onChange={ e => loginField.setValue(e.target.value) }
					disabled={ isLoading }
				/>
			</FormField>

			{ notice && <FormNotice className="error">{ notice }</FormNotice> }

			<FormButtonWrap>
				<FormButton busy={ isLoading }>Сбросить пароль</FormButton>
			</FormButtonWrap>
		</Form>
	);
}
